import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})


export class MiraieService {
	apiurl = '/api/';  // 本番
	//apiurl = '/miraie_api/api/';
	//apiurl = 'http://localhost/';

	srcurl = '/'; //本番
	// srcurl = '/miraie_api/';
	//srcurl = 'http://localhost/';

	constructor(
		private http: HttpClient,
	) { }

	post(url, param, option: any = {}) {
		let commonHeader = new HttpHeaders({
			'Content-Type': 'application/json',
			'Authorization': 'my-auth-token',
		});
		let postOption = {}
		if (option.headers) {
			commonHeader.keys().forEach(function (key) {
				if (!option.headers.has(key)) {
					option.headers.set(key, commonHeader.get(key));
				}
			});
			postOption = option;
		} else {
			postOption = Object.assign(option, { headers: commonHeader });
		}
		//console.log('url', this.apiurl + url);
		return this.http.post(this.apiurl + url, param, postOption);
	}

	get(url) {
		return this.http.get(this.apiurl + url);
	}
}
